import CourseHits from './CourseHits'
import ProviderHits from './ProviderHits'
import ScholarshipHits from './ScholarshipHits'

export { CourseHits, ScholarshipHits, ProviderHits }
